import { createTheme, alpha } from "@mui/material/styles";

// WCAG 1.4.11 / EN 301 549 require hover and focus indicators to have at
// least 3:1 contrast against adjacent colors. MUI's Button has no visible
// focus ring by default and its hover overlay is too subtle, so both states
// are defined explicitly here for every variant/color combination.
const FOCUS_RING_WIDTH = 3;

const buttonInteractionStates = ({ theme, ownerState }) => {
  const { variant, color = "primary" } = ownerState;
  // color="inherit" has no palette entry, so fall back to currentColor
  // which adapts the ring/fill to whatever text color is in context.
  const palette = theme.palette[color];
  const mainColor = palette ? palette.main : "currentColor";
  const darkColor = palette ? palette.dark : "currentColor";

  // Always a solid black ring, offset from the button, so it stays visible
  // regardless of the button's own color.
  const focusRingOutline = {
    outline: `${FOCUS_RING_WIDTH}px solid #000`,
    outlineOffset: 2,
  };

  if (variant === "contained") {
    const tonalFill = {
      backgroundColor: alpha(mainColor, 0.12),
      borderColor: mainColor,
      color: mainColor,
    };
    return {
      // Reserve space for the border so the button doesn't resize.
      boxSizing: "border-box",
      border: "1px solid transparent",
      "&:hover": tonalFill,
      "&.Mui-focusVisible": { ...tonalFill, ...focusRingOutline },
    };
  }

  if (variant === "outlined" || variant === "text") {
    const filledBackground = {
      backgroundColor: alpha(mainColor, 0.16),
      ...(variant === "outlined" && { borderColor: darkColor }),
    };
    return {
      "&:hover": filledBackground,
      "&.Mui-focusVisible": { ...filledBackground, ...focusRingOutline },
    };
  }

  return { "&.Mui-focusVisible": focusRingOutline };
};

const theme = createTheme({
  palette: {
    secondary: {
      main: "#5E35B1",
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        // The ripple animation only partially covers the button and looks
        // broken alongside the solid focus/hover fill colors above.
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: buttonInteractionStates,
      },
    },
  },
});

export default theme;
